module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n\r\n<app-shell></app-shell>\r\n\r\n\r\n<!-- <input type=\"text\" (setAddress)=\"getAddress($event)\" appGooglePlaces/> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main